import { paletteColor } from "@archlang/scene";
import type { BoardEdge } from "@archlang/scene/board";

// =============================================================================
// Default edge badge (icon / text in the middle of the arrow path)
// =============================================================================
//
// When an interface configures `widget.icon` or `widget.text` but ships no
// custom element (`widget`) or inline template (`widget.template`), the
// renderer draws a built-in pill at the edge midpoint. This is the
// zero-code path for labelling an edge: a glyph, a short caption, or both.

/** Pull the icon / text props out of an edge's widget props, if any. */
export function edgeBadgeProps(
  props: BoardEdge["widgetProps"]
): { icon?: string; text?: string; iconColor?: string; textColor?: string } | null {
  if (!props) return null;
  const rawIcon = props.get("icon");
  const rawText = props.get("text");
  const rawIconColor = props.get("icon.color");
  const rawTextColor = props.get("text.color");
  const icon = typeof rawIcon === "string" && rawIcon ? rawIcon : undefined;
  const text =
    rawText === undefined || rawText === null || rawText === ""
      ? undefined
      : String(rawText);
  if (!icon && !text) return null;
  // Both colours land in a React `style` prop, so a palette name has to become
  // pixels here or CSS paints its own colour of that word instead of ours.
  const colorOf = (raw: unknown): string | undefined =>
    typeof raw === "string" && raw ? paletteColor(raw) : undefined;
  return {
    icon,
    text,
    iconColor: colorOf(rawIconColor),
    textColor: colorOf(rawTextColor),
  };
}
